import changePasswordController from './changePassword.controller';
import template from './changePassword.html';

function changePasswordFactory($mdDialog, $http) {
  function showChangePasswordDialog(user) {
    $mdDialog.show({
      template,
      controller: changePasswordController,
      controllerAs: '$ctrl',
      locals: { user },
    });
  }
  function change({ user, password }) {
    return $http
      .post(`/admin/user/${user._id}/change-password`, { password })
      .then(response => response.data);
  }
  return { showChangePasswordDialog, change };
}
changePasswordFactory.$inject = ['$mdDialog', '$http'];
export default changePasswordFactory;



// WEBPACK FOOTER //
// ./client/app/components/user/userDetails/changePassword/changePassword.factory.js